import { useEffect } from "react";
import { useCesium } from "../../useCesium";
import { useCurrentProject } from "lib/hooks/useProject";

export function useToolEffectMeasureProjectSync() {
  const { measureToolPlugin } = useCesium();
  const { project } = useCurrentProject();

  useEffect(() => {
    if (project) {
      measureToolPlugin.setProjectGridSnapAxis(
        project.projectedCs?.projText,
        project.projectNorthDegrees,
        project.projectNorthDirection,
      );
      return;
    }
    measureToolPlugin.setProjectGridSnapAxis(null, null, null);
  }, [project]);
}
